// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AddFieldSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import DynamicThresholdField from './Izenda.DynamicThresholdField';
import UICONSTANTS from 'logic/data/Izenda.UIConstants';
const { isEmpty, isNull } = require('lodash/fp');

export default class AddFieldSetting extends Component {
  static displayName = 'AddField';

  /**
   * Open add field popup
   */
  onClick = () => {
    const { dataTree, data, reportPartContent, fieldContainerName } = this.props;

    this.props
      .openPopup(DynamicThresholdField, {
        dataTree,
        data,
        reportPartContent,
        fieldContainerName
      })
      .then(this.props.onOk);
  };

  /**
   * Get display dynamic all
   * @param {string} fieldName
   */
  getDisplayName(fieldName: string) {
    const { localization } = this.props;
    return isNull(fieldName)
      ? localization.getText('REPORTDESIGNER_LABEL_ADD_NEW_FIELD')
      : isEmpty(fieldName)
        ? UICONSTANTS.MASKED_TEXT
        : fieldName;
  }

  render() {
    const { data, className } = this.props;
    const displayName = this.getDisplayName(data.displayName);
    const containerClassName = className + ' u_flex u_flexCenterAlignItems ';

    return (
      <div className={containerClassName}>
        <div className="form-control overflow-text u_paddingLeft" title={displayName}>
          {!data.value && (
            <a>
              <span onClick={this.onClick}>{displayName}</span>
            </a>
          )}
          {data.value && <span>{displayName}</span>}
        </div>

        {data.value && (
          <a className="u_paddingLeft">
            <span className="icon-setting" onClick={this.onClick} />
          </a>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.AddFieldSetting.js